<template>
    <div>
      <h5>Product Cost List</h5>
      <ProductCogsList />
    </div>
</template>

<script>
import ProductCogsList from '@/components/product/ProductCogsList.vue'
export default {
  name: 'ProductCogs',
  components: {
    ProductCogsList
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getProductListSelect')
  }
}
</script>
